var AuthStrategy;

(function (AuthStrategy) {
  AuthStrategy["Jwt"] = "jwt";
})(AuthStrategy || (AuthStrategy = {}));

export default AuthStrategy;